import script from "./selectBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./selectBox.vue?vue&type=script&setup=true&lang=ts"

import "./selectBox.vue?vue&type=style&index=0&id=0e19dbf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e19dbf0"]])

export default __exports__